import React, { useState, useEffect, useRef } from "react";
import Preloader from "./components/Preloader";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";

import { BrowserRouter as Router } from "react-router-dom";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";



function App() {

const home = useRef(null)
const about = useRef(null)
const project = useRef(null)
const contact = useRef(null)
const tech = useRef(null)
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      {load ? (
        <Preloader load={load} />
      ) : (
        <div className="App" id={load ? "no-scroll" : "scroll"}>
          <Navbar tech={tech} home={home} about={about} project={project} contact={contact} />
          <Home tech={tech} home={home} about={about} project={project} contact={contact}/>
          {/* <ScrollToTop /> */}
          {/* <Switch>
            <Route path="/" exact component={Home}  />
            <Route path="/project" component={Projects} />
            <Route path="/about" component={About} />
            <Route path="/resume" component={Resume} />
          </Switch> */}
          {/* <Footer /> */}
        </div>
      )}
    </Router>
  );
}

export default App;
